import React from 'react'

import FirstSection from '../TrainingCenter/FirstSection'
import SecondSection from '../TrainingCenter/SecondSection'
import ThirthSection from '../TrainingCenter/ThirthSection'

import ColorPallet from '../../../utils/ColorPallet'
import FourthSection from './FourthSection'

function MainSection() {
  return (
    <div className="min-h-screen">
      {/* First Section */}
        <FirstSection />
      
      {/* Second Section */}
        <div style={{ backgroundColor: ColorPallet.primaryLightBrown }}>
        <SecondSection />
      </div>
      
      {/* Third Section */}
      <ThirthSection />

      {/* Fourth Section */}
      <FourthSection />
      
    </div>
  )
}

export default MainSection